import React from "react";
import { Patient } from "../../../system/AppState/AppPatientsState";
import AppSlideFadeIn from "../../Generic/AppSlideFadeIn";
import PatientAvatar from "../../PatientAvatar/PatientAvatar";
import PatientScreenExtraHeaderActions from "./PatientScreenExtraHeaderActions";

interface Props {
  patient: Patient;
  onClickChat: () => void;
  onClickCallPatient: () => void;
  onClickDirections: () => void;
}

const PatientScreenExtraHeader = (props: Props) => {
  return (
    <div className="PatientScreenExtraHeader">
      <PatientAvatar size="large" initials={props.patient.initials} />
      <AppSlideFadeIn delay={200}>
        <h2 className="__patientName">{props.patient.fullName}</h2>
        <div className="__patientAddress">{props.patient.address}</div>
        <div className="__patientAddress">{props.patient.address2}</div>
      </AppSlideFadeIn>
      <div style={{ alignSelf: "stretch" }}>
        <AppSlideFadeIn delay={400}>
          <PatientScreenExtraHeaderActions
            onClickChat={props.onClickChat}
            onClickCallPatient={props.onClickCallPatient}
            onClickDirections={props.onClickDirections}
          />
        </AppSlideFadeIn>
      </div>
    </div>
  );
};

export default React.memo(PatientScreenExtraHeader);
